module.exports = __webpack_public_path__ + "static/img/06.20d7c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/06.png
// module id = IFMV
// module chunks = 1